export default {
  TOGGLE: 'TOGGLE',
  EDIT: 'EDIT'
};
